import { createContext, useContext, useSyncExternalStore } from 'react';
import type { PortalFormSessionManager } from './formSessionManager';

export const PortalFormSessionContext = createContext<PortalFormSessionManager | undefined>(undefined);
export function usePortalFormSessionManager() {
  const manager = useContext(PortalFormSessionContext);
  if (!manager) throw new Error('表单会话必须在认证 Shell 内使用');
  return manager;
}
export function usePortalFormSessionSnapshot() {
  const manager = usePortalFormSessionManager();
  return useSyncExternalStore(manager.subscribe, manager.getSnapshot, manager.getSnapshot);
}
